interface SubMenu {
	title?: string;
	path?: string;
}
export interface MenuList {
	mainMenu: string;
	subMenu?: SubMenu[];
	mainPath?: string;
}

export interface MypageMenuList {
	menu: string;
	path: string;
}
export const menuList: MenuList[] = [
	{
		mainMenu: '학회소개',
		mainPath: '',
		subMenu: [
			{
				title: '학회소개',
				path: '/introduce',
			},
			{
				title: '학회 조직도',
				path: '/introduce',
			},
			{
				title: '학회연혁',
				path: '/introduce',
			},
			{
				title: '정관 및 규정',
				path: '/introduce',
			},
			{
				title: '임원',
				path: '/introduce',
			},
			{
				title: '오시는길',
				path: '/introduce',
			},
		],
	},
	{
		mainMenu: '학회활동',
		mainPath: '',
		subMenu: [
			{
				title: '학술행사 안내',
				path: '/society',
			},
			{
				title: '초록 안내 및 등록',
				path: '/society',
			},
			{
				title: '학술대회 등록',
				path: '/society',
			},
		],
	},
	{
		mainMenu: '학회회원',
		mainPath: '',
		subMenu: [
			{
				title: '가입안내',
				path: '/membership',
			},
			{
				title: '연회비 납부',
				path: '/membership',
			},
			{
				title: '특별회원사',
				path: '/membership',
			},
		],
	},
	{
		mainMenu: '간행물',
		mainPath: '',
		subMenu: [
			{
				title: '저널안내',
				path: '/publication',
			},
			{
				title: '저널검색',
				path: '/publication',
			},
			{
				title: '투고안내',
				path: '/publication',
			},
			{
				title: '광고안내',
				path: '/publication',
			},
			{
				title: '게재료 결제',
				path: '/publication',
			},
		],
	},
	{
		mainMenu: '자료실',
		mainPath: '',
		subMenu: [
			{
				title: '공지사항',
				path: '/information',
			},
			{
				title: '자유게시판',
				path: '/information',
			},
		],
	},
	{
		mainMenu: '문의하기',
		mainPath: '/contact',
		subMenu: [],
	},
	{
		mainMenu: '후원안내',
		mainPath: '',
		subMenu: [
			{
				title: '후원안내',
				path: '/sponsorship',
			},
			{
				title: '연간기부금 모금액 및 활용실적',
				path: '/sponsorship',
			},
		],
	},
];

export const mypageMenuList: MypageMenuList[] = [
	{
		menu: '기본정보',
		path: '/mypage/basic',
	},
	{ menu: '직장정보', path: '/mypage/company' },
	{ menu: '학력정보', path: '/mypage/education' },
	{ menu: '재학인증', path: '/mypage/enrollment' },
	{ menu: '비밀번호 변경', path: '/mypage/password' },
	{ menu: '서비스 이용약관', path: '/mypage/term/service' },
	{ menu: '개인정보 처리방침', path: '/mypage/term/privacy' },
];

/** 학술대회 등록비 결제·영수증·거래명세서에 쓰이는 행사명 */
export const CONF_TITLE = '2026년 춘계학술대회';

/** 초록 등록 API(conference_name) 등 학술행사명 */
export const ABSTRACT_CONFERENCE_NAME = '26년 제6차 정기총회 밎  추계학술대회';
